export default __webpack_public_path__ + "static/media/icons8-microsoft-word.e130b4d8.svg";